import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'attachLabel',
    standalone: false
})
export class AttachLabelPipe implements PipeTransform {

    static format(value: Record<string, any>, codeName = 'Code', labelName = 'Libelle'): string {
        return [codeName, labelName].map(property => value?.[property]).filter(e => !!e).join(' - ');
    }

    transform(value: Record<string, any>, codeName = 'Code', labelName = 'Libelle'): string {
        return AttachLabelPipe.format(value, codeName, labelName);
    }
}
